import React, { FC } from 'react';
import { Spacer, TextHeadingSection } from 'components';
import { Col, Grid, Row } from 'antd';
import { Instructions } from '../../components/Instructions/Instructions';

export const SectionWorking: FC = () => {
	const { lg, xl } = Grid.useBreakpoint();

	return (
		<Col>
			<Row justify={'center'}>
				<TextHeadingSection secondary>
					How do live auctions work?
				</TextHeadingSection>
			</Row>
			<Row justify={'center'}>
				<Instructions
					instructions={[
						{
							description:
								'Sign up so we can let you know when we’re hosting our first auction',
							iconUrl: '/assets/steps--sign-up.svg',
							title: 'Sign Up',
						},
						{
							description:
								'We’ll keep you updated, no need to keep checking back',
							iconUrl: '/assets/steps--be-notified.svg',
							title: 'Be Notified',
						},
						{
							description:
								'Jump in with your Mint Gold Dust account and compete against top collectors for exclusive drops',
							iconUrl: '/assets/steps--join-the-auction.svg',
							title: 'Join the Auction',
						},
					]}
				/>
			</Row>
		</Col>
	);
};
